module.exports = __webpack_public_path__ + "static/media/step3.17e4a331.png";